import React from "react";
export var SkeletonForm = React.memo(function () {
    return (React.createElement("div", { className: "h-full w-full bg-white p-4 flex flex-col space-y-6 overflow-y-auto md:h-auto md:max-h-full md:px-8 md:py-1 md:space-y-0 md:divide-y md:divide-gray-200 md:rounded-lg" }, new Array(8).fill(null).map(function (_, index) {
        return (React.createElement("div", { className: "flex flex-col items-start justify-center md:flex-row md:py-5", key: index },
            React.createElement("div", { className: "animate-pulse rounded-full p-4 bg-gray-200 w-24 md:min-w-[17.5rem] mb-1 md:mb-0 md:mr-6" }),
            React.createElement("div", { className: "flex-1 w-full animate-pulse p-4 bg-gray-200 rounded-full" })));
    })));
});
